export default {
  title:       'Gestão dos meus dados',
  description: 'Revisão de decisões tomadas unicamente com base em tratamento automatizado de dados pessoais que afetem seus interesses',
};
